// extracted by mini-css-extract-plugin
export default {"wrapper":"vGVWoIWfZU_OZ7C9ru0y","addBtn":"hCMrUcFSEfxaRKRi_tcx"};